export const PAGE_PARAM = 'p';
export const PAGE_SIZE = 25;
export const DOTS = '...';
export const PAGE_NUMBER = 'pageNumber';
